// document.addEventListener("DOMContentLoaded", (event) => {
//   if (window.location.href.indexOf("products") > -1) {
//     setTimeout(function(){
//       var elementWithAttribute = document.querySelector('span[data-price]');
//       var elementWithAttribute_text = elementWithAttribute.getAttribute("data-customPrice");
//       elementWithAttribute.textContent = elementWithAttribute_text;
//     },500);
//   }
// });
document.addEventListener("click", function (event) {
    if (event.target.classList.contains('quantity-selector__button') || event.target.parentNode.classList.contains('quantity-selector__button')) {
        var closestCustomQuantityUpdate = event.target.closest(".custom_quantity_update");
        console.log(closestCustomQuantityUpdate); // Log the closestCustomQuantityUpdate

        if (closestCustomQuantityUpdate) {
            var realQtyInput = closestCustomQuantityUpdate.querySelector(".real_qty_input");
            if (realQtyInput) {
                closestCustomQuantityUpdate.querySelector(".fake_qty_input").value = parseInt(realQtyInput.value) / parseInt(realQtyInput.getAttribute("data-increment-value"));
                if (window.location.href.indexOf("products") > -1) {
                    var elementWithAttribute = document.querySelector('span[data-price]');
                    elementWithAttribute.textContent = `$${parseFloat((parseInt(realQtyInput.getAttribute("data-currentPrice"))) / 100).toFixed(2)}`;

                    // Log a message when the quantity is updated
                    console.log('Quantity Updated:', realQtyInput.value);
                }
            }
        }
    }
});

